import { Bloctel } from "../../../../types";

export const showBloctel = (bloctel?: Bloctel) => bloctel === "Blocked";
